__turbopack_context__.v({
  "placeholder": "Lk7J9a_placeholder",
  "scroll": "Lk7J9a_scroll",
  "slide": "Lk7J9a_slide",
  "slideshow": "Lk7J9a_slideshow",
  "slideshowSlider": "Lk7J9a_slideshowSlider",
});
